import logger from "../../../utils/logger";
import {
  addRemedy,
  editRemedy,
  loadRemedy,
  loadRemedySuccess
} from "../reducer/remedy";
import * as uiActions from "../reducer/ui";

const loadRemedyFlow = ({ getRemedy }) => ({ dispatch, getState }) => (
  next
) => async (action) => {
  next(action);
  if (action.type === loadRemedy.type) {
    dispatch(uiActions.setLoading(true));
    try {
      const response = await getRemedy(action.payload);
      dispatch(loadRemedySuccess(response.data));
      logger()(response.data);
    } catch (error) {
      if (error.response && error.response.data && error.response.data.msg) {
        dispatch(uiActions.setError(error.response.data.msg));
      } else dispatch(uiActions.setError(error.message));
    }
    dispatch(uiActions.setLoading(false));
  }
};

const addRemedyFlow = ({ postRemedy }) => ({ dispatch }) => (next) => async (
  action
) => {
  next(action);
  if (action.type === addRemedy.type) {
    dispatch(uiActions.setLoading(true));
    try {
      const response = await postRemedy(action.payload);
      logger()(response.data);
      dispatch(uiActions.setToast(response.data.msg))//"Successfully Suggested"));
    } catch (error) {
      if (error.response && error.response.data && error.response.data.msg) {
        dispatch(uiActions.setError(error.response.data.msg));
      } else dispatch(uiActions.setError(error.message));
    }
    dispatch(uiActions.setLoading(false));
  }
};

const editRemedyFlow = ({ postEditRemedy }) => ({ dispatch, getState }) => (
  next
) => async (action) => {
  next(action);
  if (action.type === editRemedy.type) {
    dispatch(uiActions.setLoading(true));
    try {
      const response = await postEditRemedy(
        getState().remedy.remedyItem._id,
        action.payload
      );
      logger()(response.data);
      
      dispatch(uiActions.setToast(response.data.msg))//"Successfully Suggested"));
    } catch (error) {
      if (error.response && error.response.data && error.response.data.msg) {
        dispatch(uiActions.setError(error.response.data.msg));
      } else dispatch(uiActions.setError(error.message));
    }
    dispatch(uiActions.setLoading(false));
  }
};

const remedyFlow = [loadRemedyFlow, addRemedyFlow, editRemedyFlow];

export default remedyFlow;
